<template>
    <div>
        <div v-if="isExporting">
            <h3 class="d-flex justify-center">{{ getPercentage() }}</h3>
            <h5 class="d-flex justify-center grey--text">{{ getTime() }}</h5>
            <v-progress-linear
                :value="exportingProgress"
                :indeterminate="exportingProgress == 0" 
                height="4" 
                color="#4CAF50" 
                background-color="grey lighten-2"
            >
            </v-progress-linear>
        </div>
        <h1 class="d-flex justify-center display-3 primary--text ma-5">Área Lowi</h1>
        <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
            <template v-slot:activator="{ on, attrs }">
                <div class="d-flex justify-center">
                    <v-btn
                        x-large
                        depressed
                        v-bind="attrs"
                        v-on="on"
                    >
                        <div>
                            <p class="primary--text mb-n1">Filtrar</p>
                            <small class="primary--text mt-n1">{{date}}</small>
                        </div>
                        <v-icon color="primary" right>mdi-calendar</v-icon>
                    </v-btn>
                    <v-btn
                        x-large
                        depressed
                        @click="agentTest"
                    >
                        <v-icon>mdi-printer</v-icon>
                    </v-btn>
                </div>
            </template>
            <v-date-picker
                type="month"
                v-model="date"
                @input="menu2 = false"
            ></v-date-picker>
        </v-menu>
        <v-row class="ma-4">
            <v-col cols="12" md="7">
                <LowiSellSummary />
            </v-col>
            <v-col cols="12" md="5">
                <LowiPayments />
                <LowiNextMonth />
            </v-col>
        </v-row>
        <v-fab-transition>
            <v-btn
                color="green"
                fab
                large
                dark
                bottom
                right
                fixed
                @click="isOpen = true"
            >
                <v-icon large>mdi-microsoft-excel</v-icon>
            </v-btn>
        </v-fab-transition>
        <v-dialog v-model="isOpen" max-width="700px">
            <v-card class="pa-2">
                <v-card-title class="d-flex justify-center">
                    <h2 class="font-weight-light primary--text">Subir Excel</h2>
                </v-card-title>
                <v-card-text>
                    <FileUpload
                        action="lowi/uploadMonthlyFee"
                        paramName="file"
                        allowedExtensions="['xls', 'xlsx']"
                        icon="mdi-microsoft-excel"
                    />
                </v-card-text>
                <v-card-actions class="mt-n10">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red"
                        text
                        @click="isOpen = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LowiNextMonth from './LowiNextMonth.vue';
import LowiPayments from './LowiPayments.vue';
import LowiSellSummary from './LowiSellSummary.vue';
import FileUpload from '@/components/RRHH/AccountsView/FormCuenta/FileUpload.vue';
import axios from 'axios';

export default {
    name: 'LowiBase',
    data: () => ({
        isOpen: false,
        elapsed: 0,
        date: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().substr(0, 7),
        menu2: false,
    }),
    components: {
        LowiNextMonth,
        LowiPayments,
        LowiSellSummary,
        FileUpload,
    },
    methods: {
        formatTime(time) {
            let seconds = Math.floor((time / 1000) % 60);
            let minutes = Math.floor((time / (1000 * 60)) % 60);
            let hours = Math.floor((time / (1000 * 60 * 60)) % 24);

            return `${hours}h ${minutes}m ${seconds}s`;
        },
        getTime(){
            if(this.exportingProgress != 0 && !isNaN(this.exportingProgress)){
                let formattedTime = this.formatTime(
                    (new Date().getTime() - this.elapsed) * (100 - this.exportingProgress) / this.exportingProgress
                );
            
                return formattedTime;
            }

            return 'Calculando...';
        },
        getPercentage(){
            if(this.exportingProgress != 0 && !isNaN(this.exportingProgress)){
                return `${this.exportingProgress.toFixed(0)} %`;
            }

            return '0%';
        },
        agentTest(){
            this.$store.dispatch('agent/agentCustomerInfo');
        },
    },
    computed: {
        ...mapState('util', {
            exportingProgress: (state) => state.exportingProgress,
            isExporting: (state) => state.isExporting,
        }),
    },
    watch: {
        isExporting(val){
            if(val){
                this.elapsed = new Date().getTime();
            }
        },
        date(val) {
            this.$store.dispatch('lowi/getLowiData', val);
        },
    },
    beforeMount() {
        this.$store.dispatch('lowi/getLowiData', this.date);
    },
}
</script>
